import { render, staticRenderFns } from "./bulletinAdd.vue?vue&type=template&id=2c03393c&scoped=true"
import script from "./bulletinAdd.vue?vue&type=script&lang=js"
export * from "./bulletinAdd.vue?vue&type=script&lang=js"
import style0 from "../../../company/statistics/css/commonCompany.css?vue&type=style&index=0&id=2c03393c&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c03393c",
  null
  
)

export default component.exports